export const hidenMessageAPI = [
  "user-preferences-general",
  "/pts_app/project-root-task/",
  "/pts_app/project-sprint/",
  "/pts_app/project-summary/",
  "/pts_app/previous-hours-management/",
  "/pts_app/check-project-estimated/",
  "/pts_app/daily-spent-hours/",
  "/pts_app/employee-dashboard/",
  "/pts_app/signup-email-check/",
  "/pts_app/user-current-role/",
  "/pts_app/current-user-details/",
  "/pts_app/save-project-as-template/",
  "/signup-email-check/",
  "/dropdown/PTS%20Emp/",
  "/dropdown/PTS Emp/",
  "/api/dropdown/PTS%20Emp/",
  "/api/dropdown/PTS Emp/",
  "dropdown/PTS%20Emp",
  "dropdown/PTS Emp",
  "dropdown/user/",
  "dropdown/TenantRole/",
  "/dynamic-model/PTS%20Employee%20Checkin/",
  "/pts_app/full-employee-list/",
  "/pts_app/billing/",
  "/pts_app/invoice/",
  "/pts_app/project-client-data/",
  "/pts_app/payment-status/",
  "/pts_app/dashboard-listing/",
  "/pts_app/pts-task-listing/",
  "/pts_app/invoice-reminder/",
  "/pts_app/pts-onbonding-status/",
  "/pts_app/change-request/",
  "/pts_app/change-request/account/",
  "/pts_app/change-request/google-sheet/",
  "/pts_app/purchase-approval/",
  "/pts_app/leave-approval/",
  "/pts_app/expense-summary/",
  "/pts_app/expense-recurring/?year=",
  "/pts_app/purchase-approval/",
];
